import * as Yup from 'yup';
import PageHeader from 'src/core/ui/PageHeader';
import Footer from 'src/core/ui/helpers/Footer';
import ContentCardsContainer, { ContentCard, CardTitle } from 'src/core/ui/ContentCard';
import ViewStreamOutlinedIcon from '@mui/icons-material/ViewStreamOutlined';
import { Formik } from 'formik';
import SaveIcon from '@mui/icons-material/Save';
import AddTwoToneIcon from '@mui/icons-material/AddTwoTone';
import { FormField } from 'src/core/forms/FormField';
import CustomButton from 'src/core/ui/CustomButton';
import useSubmit from 'src/core/forms/useSubmit';
import useRedirectOnCreate from 'src/core/forms/useRedirectOnCreate';
import { buildProductLinesRequest } from 'src/core/forms/submit/submitRequests';
import FormHelper from 'src/core/forms/formHelper';
import { MenuItem } from '@mui/material';
import { useManufacturerOptions } from 'src/core/forms/useOptions';
import { useProductLineForm } from 'src/core/forms/useForms';
import Delete from '@mui/icons-material/Delete';
import useRequest from 'src/core/api/useRequest';
import { deleteProductLine } from 'src/core/api/apiRequests';

function ProductLineFormPage() {
    const [editId, pageTitle, , , isEditPage] = FormHelper.getEditPageConfig('ProductLine', buildProductLinesRequest, buildProductLinesRequest);
    const initialValues = useProductLineForm(editId, defaultInitialValues);
    const manufacturerOptions = useManufacturerOptions();
    const [result, submit] = useSubmit(buildProductLinesRequest);
    const [deleteResult, setDeleteRequest] = useRequest({ logLevel: ['error', 'success'] });
    useRedirectOnCreate(result, editId, 'Id', '/products/product-lines/edit?id=');
    useRedirectOnCreate(deleteResult, null, 'Id', '/products/product-lines');

    return (
        <>
            <Formik initialValues={initialValues} validateOnBlur validateOnChange={false} validationSchema={schema} onSubmit={submit} enableReinitialize>
                {(props): JSX.Element => (
                    <div>
                        <PageHeader title={pageTitle} initialValues={initialValues} subTitle="Create and edit Product Line" components={[
                            { component: <CustomButton isSubmitting={props.isSubmitting} onClick={props.handleSubmit} title="Save" icon={<SaveIcon />} /> },
                            ...(isEditPage ? [{ component: <CustomButton color="error" title="Delete" icon={<Delete />} onClick={() => setDeleteRequest(deleteProductLine(editId))} /> }] : []),
                            { isInGroupedMenu: true, component: <CustomButton variant="text" title="New Product Line" icon={<AddTwoToneIcon />} actionUrl="/products/product-lines/create" /> },
                        ]} />
                        <ContentCardsContainer>
                            <ContentCard cardId="Product Line Information" md={12} formLayout cardHeader={<CardTitle icon={<ViewStreamOutlinedIcon />}>Product Line Information</CardTitle>}>
                                <FormField fieldProps={{ name: 'Name', label: 'Product Line Name', md: 12 }} formikProps={props} />
                                <FormField fieldProps={{ name: 'Manufacturer', select: true, label: 'Manufacturer Name', md: 6 }} formikProps={props}>
                                    {manufacturerOptions?.map(option => (<MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>))}
                                </FormField>
                                <FormField fieldProps={{ name: 'CreateDate', date: true, label: 'Created', md: 6, disabled: true }} formikProps={props} />
                                <FormField fieldProps={{ name: 'ModifyDate', date: true, label: 'Modified', md: 6, disabled: true }} formikProps={props} />
                            </ContentCard>
                        </ContentCardsContainer>
                    </div>
                )}
            </Formik>
            <Footer />
        </>
    );
}

const schema = Yup.object().shape({ Name: Yup.string().required('Enter the product line name.') });
const defaultInitialValues: any = { Name: '' };

export default ProductLineFormPage;
